type ButtonColour =
  | "Theme"
  | "ThemeLight"
  | "ThemeAlt"
  | "White"
  | "WhiteAlt"
  | "Red"
  | "RedAlt";

type ButtonVariety = "Big" | "Alt";

// NOTE: omitted "color" as it may confuse people
interface ButtonProps
  extends Omit<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    "color" | "className"
  > {
  variety?: ButtonVariety;
  colour?: ButtonColour;
  additionalClassNames?: string;
  dontAddBtnClass?: boolean;
  dontAddDisabledClass?: boolean;
  dontAddIgnoreHighlightClass?: boolean;
  disabledClass?: "DisabledBackground" | "DisabledOpacity";
  icon?: React.ReactNode;
}

// IDEA: Add logic for ReactTooltip from `react-tooltip`
const Button: React.FC<React.PropsWithChildren<ButtonProps>> = ({
  variety,
  colour = "",
  additionalClassNames = "",
  dontAddBtnClass = false,
  dontAddDisabledClass = false,
  dontAddIgnoreHighlightClass = false,
  disabledClass = "DisabledBackground",
  icon,
  children,
  // All other <button /> props
  title,
  type,
  ...restProps
}) => {
  const buttonClasses = `${dontAddBtnClass ? "" : "Btn"} ${
    dontAddIgnoreHighlightClass ? "" : "IgnoreTouchHighlight"
  } ${
    !dontAddDisabledClass && !!restProps.disabled ? disabledClass : ""
  } ${varietyToClassName(variety)} ${colour} ${additionalClassNames}`;
  return (
    <button
      type={type || "button"}
      className={buttonClasses}
      title={buildBtnTitle(title, children)}
      aria-disabled={!!restProps.disabled}
      {...restProps}
    >
      {/* {icon && <span className="BtnIconParent">{icon}</span>} */}
      {/* {icon ? (
        <div className="DisplayFlex SpaceBetween -AlignBaseline AlignCentre -BtnIconParent">
          <div>{icon}</div>
          <div>{children}</div>
          <div>{icon}</div>
        </div>
      ) : (
        children
      )} */}
      {icon && <span className="BtnIconParent">{icon}</span>}
      {children}
    </button>
  );
};

const varietyToClassName = (variety: ButtonProps["variety"]): string => {
  switch (variety) {
    case "Big":
      return "Big";
    default:
      return "";
  }
};

const buildBtnTitle = (
  btnTitle: ButtonProps["title"],
  content: ButtonProps["children"]
): ButtonProps["title"] =>
  btnTitle ? btnTitle : typeof content === "string" ? content : undefined;

export default Button;
